import { cleanSpaceInString } from "helpers/validation/createValidation";

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_STRONG_LENGTH = 12;

export type PasswordStrength = {
  score: number;
  label: string;
  color: "text.disabled" | "error.main" | "orange.contrast" | "text.secondary" | "green.contrast";
  hasLettersAndDigits: boolean;
  hasLongLength: boolean;
  hasMinLength: boolean;
  hasMixedCase: boolean;
};

const LETTERS_AND_DIGITS_REGEXP = /(?=.*[A-Za-zА-Яа-яЁё])(?=.*\d)/;
const UPPERCASE_REGEXP = /[A-ZА-ЯЁ]/;
const LOWERCASE_REGEXP = /[a-zа-яё]/;

export const hasPasswordLettersAndDigits = (password: string) => LETTERS_AND_DIGITS_REGEXP.test(password);

export const getPasswordStrength = (password: string): PasswordStrength => {
  const hasMinLength = password.length >= PASSWORD_MIN_LENGTH;
  const hasLettersAndDigits = hasPasswordLettersAndDigits(password);
  const hasMixedCase = UPPERCASE_REGEXP.test(password) && LOWERCASE_REGEXP.test(password);
  const hasLongLength = password.length >= PASSWORD_STRONG_LENGTH;
  const score = [hasMinLength, hasLettersAndDigits, hasMixedCase, hasLongLength].filter(Boolean).length;

  if (!password.length) {
    return {
      score,
      label: "Минимум 8 символов, буквы и цифры",
      color: "text.disabled",
      hasMinLength,
      hasLettersAndDigits,
      hasMixedCase,
      hasLongLength,
    };
  }

  if (!hasMinLength) {
    return {
      score,
      label: "Слишком короткий, нужно минимум 8 символов",
      color: "error.main",
      hasMinLength,
      hasLettersAndDigits,
      hasMixedCase,
      hasLongLength,
    };
  }

  if (!hasLettersAndDigits) {
    return {
      score,
      label: "Добавьте буквы и цифры",
      color: "orange.contrast",
      hasMinLength,
      hasLettersAndDigits,
      hasMixedCase,
      hasLongLength,
    };
  }

  if (score <= 2) {
    return {
      score,
      label: "Нормальный пароль",
      color: "text.secondary",
      hasMinLength,
      hasLettersAndDigits,
      hasMixedCase,
      hasLongLength,
    };
  }

  return {
    score,
    label: "Надежный пароль",
    color: "green.contrast",
    hasMinLength,
    hasLettersAndDigits,
    hasMixedCase,
    hasLongLength,
  };
};

export const parseFullName = (fullName: string) => {
  const cleanedFullName = cleanSpaceInString(fullName);
  const [lastName = "", firstName = "", ...middleNameParts] = cleanedFullName.split(" ").filter(Boolean);

  return {
    firstName,
    lastName,
    middleName: middleNameParts.join(" ") || undefined,
  };
};

export const validateFullName = (fullName: string) => {
  const cleanedFullName = cleanSpaceInString(fullName);
  const fullNameParts = cleanedFullName.split(" ").filter(Boolean);

  return fullNameParts.length >= 2 || "Введите фамилию и имя";
};
